module.exports = __webpack_public_path__ + "static/media/pasta.51723af1.png";